/* cSpell:disable */

import { api } from '@ppwr/convex/_generated/api'
import { Doc, Id } from '@ppwr/convex/_generated/dataModel'
import { useHandHistoryQuery } from '../hooks/convex/useGameState'

// Win by fold example
export const mockCompletedHand1: Doc<'handHistory'> = {
  _creationTime: 1767378265065.17,
  _id: 'jh71zza6xy39yfgx5rcv0hndwn7yfe33' as Id<'handHistory'>,
  actions: [
    {
      action: 'blind',
      amount: 100,
      boardState: 'deal',
      playerId: 'jn76qv8gn0ev7hqsrmyq5wg2q57yfp8y',
      timestamp: 1767378164916,
      userId: 'bot-jd72s9rs6yqqff7j5mwef89m9d7yeygp-2'
    },
    {
      action: 'blind',
      amount: 50,
      boardState: 'deal',
      playerId: 'jn7caz3h51jtjcykgdgfjp1k297yf057',
      timestamp: 1767378164916,
      userId: 'bot-jd72s9rs6yqqff7j5mwef89m9d7yeygp-0'
    },
    {
      action: 'call',
      amount: 100,
      boardState: 'deal',
      playerId: 'jn7aqn2sqjtdch4qr97zn9mr5s7yf2c9',
      timestamp: 1767378194112,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      action: 'raise',
      amount: 300,
      boardState: 'deal',
      playerId: 'jn70m31trwve2cycjrjy5kx7pn7ye3qa',
      timestamp: 1767378197205,
      userId: 'bot-jd72s9rs6yqqff7j5mwef89m9d7yeygp-1'
    },
    {
      action: 'fold',
      boardState: 'deal',
      playerId: 'jn7caz3h51jtjcykgdgfjp1k297yf057',
      timestamp: 1767378200571,
      userId: 'bot-jd72s9rs6yqqff7j5mwef89m9d7yeygp-0'
    },
    {
      action: 'fold',
      boardState: 'deal',
      playerId: 'jn76qv8gn0ev7hqsrmyq5wg2q57yfp8y',
      timestamp: 1767378205060,
      userId: 'bot-jd72s9rs6yqqff7j5mwef89m9d7yeygp-2'
    },
    {
      action: 'fold',
      boardState: 'deal',
      playerId: 'jn7aqn2sqjtdch4qr97zn9mr5s7yf2c9',
      timestamp: 1767378265065,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    }
  ],
  communityCards: [],
  completedAt: 1767378265065,
  gameId: 'jd72s9rs6yqqff7j5mwef89m9d7yeygp' as Id<'games'>,
  handNumber: 2,
  pot: 150,
  potDistribution: {
    potWinners: [
      {
        potIndex: 0,
        winners: [
          {
            amount: 700,
            hand: {
              cards: ['Qs', 'Ad'],
              description: 'A High',
              rank: 'High Card'
            },
            playerId: 'jn70m31trwve2cycjrjy5kx7pn7ye3qa',
            playerName: 'Bot 2',
            userId: 'bot-jd72s9rs6yqqff7j5mwef89m9d7yeygp-1'
          }
        ]
      }
    ],
    totalAwarded: 700
  },
  winners: [
    {
      amount: 700,
      cards: ['Qs', 'Ad'],
      handDescription: 'All other players folded',
      handRank: 'Win by fold',
      playerId: 'jn70m31trwve2cycjrjy5kx7pn7ye3qa',
      playerName: 'Bot 2',
      userId: 'bot-jd72s9rs6yqqff7j5mwef89m9d7yeygp-1'
    }
  ]
}

// Weird one: two players, each pair A's, but not split pot
export const mockCompletedHand2: Doc<'handHistory'> = {
  _creationTime: 1768400578806.763,
  _id: 'jh7e4jya6vvzpsmryzhvqaryfs7z67dz' as Id<'handHistory'>,
  actions: [
    {
      action: 'blind',
      amount: 50,
      boardState: 'deal',
      playerId: 'jn79eweqqg54ndgsfr2cb0fv557z7kyf',
      timestamp: 1768400530011,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      action: 'blind',
      amount: 100,
      boardState: 'deal',
      playerId: 'jn7eydq8sz6kvxgjcmy8d66dtx7z6xn0',
      timestamp: 1768400530011,
      userId: 'bot-jd7b0mktgabtgk59cymqt3pwfh7z6j2d-0'
    },
    {
      action: 'call',
      amount: 100,
      boardState: 'deal',
      playerId: 'jn79eweqqg54ndgsfr2cb0fv557z7kyf',
      timestamp: 1768400537232,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      action: 'raise',
      amount: 400,
      boardState: 'deal',
      playerId: 'jn7eydq8sz6kvxgjcmy8d66dtx7z6xn0',
      timestamp: 1768400540696,
      userId: 'bot-jd7b0mktgabtgk59cymqt3pwfh7z6j2d-0'
    },
    {
      action: 'fold',
      boardState: 'deal',
      playerId: 'jn75w62301ch7ka4qzwp7fd73d7z7xa5',
      timestamp: 1768400542746,
      userId: 'bot-jd7b0mktgabtgk59cymqt3pwfh7z6j2d-1'
    },
    {
      action: 'call',
      amount: 400,
      boardState: 'deal',
      playerId: 'jn79eweqqg54ndgsfr2cb0fv557z7kyf',
      timestamp: 1768400544949,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      action: 'check',
      boardState: 'flop',
      playerId: 'jn79eweqqg54ndgsfr2cb0fv557z7kyf',
      timestamp: 1768400550964,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      action: 'check',
      boardState: 'flop',
      playerId: 'jn7eydq8sz6kvxgjcmy8d66dtx7z6xn0',
      timestamp: 1768400553432,
      userId: 'bot-jd7b0mktgabtgk59cymqt3pwfh7z6j2d-0'
    },
    {
      action: 'check',
      boardState: 'turn',
      playerId: 'jn79eweqqg54ndgsfr2cb0fv557z7kyf',
      timestamp: 1768400558734,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      action: 'bet',
      amount: 400,
      boardState: 'turn',
      playerId: 'jn7eydq8sz6kvxgjcmy8d66dtx7z6xn0',
      timestamp: 1768400561076,
      userId: 'bot-jd7b0mktgabtgk59cymqt3pwfh7z6j2d-0'
    },
    {
      action: 'call',
      amount: 400,
      boardState: 'turn',
      playerId: 'jn79eweqqg54ndgsfr2cb0fv557z7kyf',
      timestamp: 1768400563837,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      action: 'check',
      boardState: 'river',
      playerId: 'jn79eweqqg54ndgsfr2cb0fv557z7kyf',
      timestamp: 1768400570123,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      action: 'check',
      boardState: 'river',
      playerId: 'jn7eydq8sz6kvxgjcmy8d66dtx7z6xn0',
      timestamp: 1768400574802,
      userId: 'bot-jd7b0mktgabtgk59cymqt3pwfh7z6j2d-0'
    }
  ],
  communityCards: ['Jd', '6c', '5h', '3c', '8c'],
  completedAt: 1768400578806,
  gameId: 'jd7b0mktgabtgk59cymqt3pwfh7z6j2d' as Id<'games'>,
  handNumber: 3,
  pot: 1600,
  potDistribution: {
    potWinners: [
      {
        potIndex: 0,
        winners: [
          {
            amount: 800,
            hand: {
              cards: ['Ah', 'Ac'],
              description: "Pair, A's",
              rank: 'Pair'
            },
            playerId: 'jn7eydq8sz6kvxgjcmy8d66dtx7z6xn0',
            playerName: 'Bot 1',
            userId: 'bot-jd7b0mktgabtgk59cymqt3pwfh7z6j2d-0'
          },
          {
            amount: 800,
            hand: {
              cards: ['Ad', 'As'],
              description: "Pair, A's",
              rank: 'Pair'
            },
            playerId: 'jn75w62301ch7ka4qzwp7fd73d7z7xa5',
            playerName: 'Bot 2',
            userId: 'bot-jd7b0mktgabtgk59cymqt3pwfh7z6j2d-0'
          }
        ]
      }
    ],
    totalAwarded: 1600
  },
  winners: [
    {
      amount: 1600,
      cards: ['Ah', 'Ac'],
      handDescription: "Pair, A's",
      handRank: 'Pair',
      playerId: 'jn7eydq8sz6kvxgjcmy8d66dtx7z6xn0',
      playerName: 'Bot 1',
      userId: 'bot-jd7b0mktgabtgk59cymqt3pwfh7z6j2d-0'
    }
  ]
}

// Side pots example: VikingTester wins 2 pots, VikingDevPP wins 1
export const mockCompletedSidePots1: Doc<'handHistory'> = {
  _creationTime: 1771613098712.708,
  _id: 'jh77y16rhfchb1cvke1m4kzjqx81h7mt' as Id<'handHistory'>,
  actions: [
    {
      action: 'blind',
      amount: 100,
      boardState: 'deal',
      playerId: 'jn76sdqjes1q2rgtcfbpjj7eqs81h74a',
      timestamp: 1771613072033,
      userId: 'bot-jd7dkjy2v68wcexdnnj1s1t20s81hgwc-added-1771613012325-0'
    },
    {
      action: 'blind',
      amount: 50,
      boardState: 'deal',
      playerId: 'jn721qzjewxkm8c0wvhxc0tgj581gk1f',
      timestamp: 1771613072033,
      userId: 'auth0|68f157a0dd81c0033db63b18'
    },
    {
      action: 'allin',
      amount: 9700,
      boardState: 'deal',
      playerId: 'jn72g5zxwqr8hz0g8j7yzhd59s81gtha',
      timestamp: 1771613083227,
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      action: 'fold',
      boardState: 'deal',
      playerId: 'jn72xz8akyh4d1rv7981h02x4h81gk3n',
      timestamp: 1771613087601,
      userId: 'bot-jd7dkjy2v68wcexdnnj1s1t20s81hgwc-added-1771613012325-1'
    },
    {
      action: 'allin',
      amount: 10300,
      boardState: 'deal',
      playerId: 'jn721qzjewxkm8c0wvhxc0tgj581gk1f',
      timestamp: 1771613093208,
      userId: 'auth0|68f157a0dd81c0033db63b18'
    },
    {
      action: 'fold',
      boardState: 'deal',
      playerId: 'jn76sdqjes1q2rgtcfbpjj7eqs81h74a',
      timestamp: 1771613097704,
      userId: 'bot-jd7dkjy2v68wcexdnnj1s1t20s81hgwc-added-1771613012325-0'
    }
  ],
  communityCards: ['Ks', 'Ts', '4s', 'Jh', 'Kd'],
  completedAt: 1771613098712,
  gameId: 'jd7dkjy2v68wcexdnnj1s1t20s81hgwc' as Id<'games'>,
  handNumber: 8,
  playerTimelines: [
    {
      boardState: 'init',
      players: [
        {
          cards: ['4h', 'Tc'],
          chips: 9700,
          kind: 'human',
          playerId: 'jn72g5zxwqr8hz0g8j7yzhd59s81gtha',
          position: 'sb',
          seatId: 0,
          state: 'active',
          userId: 'auth0|68b1fea866fee77b8ca52f6b'
        },
        {
          cards: [],
          chips: 10000,
          kind: 'bot',
          playerId: 'jn76sdqjes1q2rgtcfbpjj7eqs81h74a',
          position: 'none',
          seatId: 3,
          state: 'waiting',
          userId: 'bot-jd7dkjy2v68wcexdnnj1s1t20s81hgwc-added-1771613012325-0'
        },
        {
          cards: ['6d', '3d'],
          chips: 10300,
          kind: 'human',
          playerId: 'jn721qzjewxkm8c0wvhxc0tgj581gk1f',
          position: 'bb',
          seatId: 7,
          state: 'active',
          userId: 'auth0|68f157a0dd81c0033db63b18'
        },
        {
          cards: [],
          chips: 10000,
          kind: 'bot',
          playerId: 'jn72xz8akyh4d1rv7981h02x4h81gk3n',
          position: 'none',
          seatId: 8,
          state: 'waiting',
          userId: 'bot-jd7dkjy2v68wcexdnnj1s1t20s81hgwc-added-1771613012325-1'
        }
      ]
    },
    {
      boardState: 'deal',
      players: [
        {
          cards: ['Tc', '2d'],
          chips: 9700,
          kind: 'human',
          playerId: 'jn72g5zxwqr8hz0g8j7yzhd59s81gtha',
          position: 'none',
          seatId: 0,
          state: 'active',
          userId: 'auth0|68b1fea866fee77b8ca52f6b'
        },
        {
          cards: ['6c', '4c'],
          chips: 9900,
          kind: 'bot',
          playerId: 'jn76sdqjes1q2rgtcfbpjj7eqs81h74a',
          position: 'bb',
          seatId: 3,
          state: 'active',
          userId: 'bot-jd7dkjy2v68wcexdnnj1s1t20s81hgwc-added-1771613012325-0'
        },
        {
          cards: ['9h', '5s'],
          chips: 10250,
          kind: 'human',
          playerId: 'jn721qzjewxkm8c0wvhxc0tgj581gk1f',
          position: 'sb',
          seatId: 7,
          state: 'active',
          userId: 'auth0|68f157a0dd81c0033db63b18'
        },
        {
          cards: ['Ad', '6s'],
          chips: 10000,
          kind: 'bot',
          playerId: 'jn72xz8akyh4d1rv7981h02x4h81gk3n',
          position: 'd',
          seatId: 8,
          state: 'active',
          userId: 'bot-jd7dkjy2v68wcexdnnj1s1t20s81hgwc-added-1771613012325-1'
        }
      ]
    },
    {
      boardState: 'showdown',
      players: [
        {
          cards: ['Tc', '2d'],
          chips: 19500,
          kind: 'human',
          playerId: 'jn72g5zxwqr8hz0g8j7yzhd59s81gtha',
          position: 'none',
          seatId: 0,
          state: 'allin',
          userId: 'auth0|68b1fea866fee77b8ca52f6b'
        },
        {
          cards: ['9h', '5s'],
          chips: 600,
          kind: 'human',
          playerId: 'jn721qzjewxkm8c0wvhxc0tgj581gk1f',
          position: 'sb',
          seatId: 7,
          state: 'allin',
          userId: 'auth0|68f157a0dd81c0033db63b18'
        },
        {
          cards: ['6c', '4c'],
          chips: 9900,
          kind: 'bot',
          playerId: 'jn76sdqjes1q2rgtcfbpjj7eqs81h74a',
          position: 'bb',
          seatId: 3,
          state: 'folded',
          userId: 'bot-jd7dkjy2v68wcexdnnj1s1t20s81hgwc-added-1771613012325-0'
        },
        {
          cards: ['Ad', '6s'],
          chips: 10000,
          kind: 'bot',
          playerId: 'jn72xz8akyh4d1rv7981h02x4h81gk3n',
          position: 'd',
          seatId: 8,
          state: 'folded',
          userId: 'bot-jd7dkjy2v68wcexdnnj1s1t20s81hgwc-added-1771613012325-1'
        }
      ]
    }
  ],
  pot: 20100,
  potDistribution: {
    potWinners: [
      {
        potIndex: 0,
        winners: [
          {
            amount: 300,
            hand: {
              cards: ['Tc', '2d'],
              description: "Two Pair, K's & 10's",
              rank: 'Two Pair'
            },
            playerId: 'jn72g5zxwqr8hz0g8j7yzhd59s81gtha',
            playerName: 'VikingTester',
            userId: 'auth0|68b1fea866fee77b8ca52f6b'
          }
        ]
      },
      {
        potIndex: 1,
        winners: [
          {
            amount: 19200,
            hand: {
              cards: ['Tc', '2d'],
              description: "Two Pair, K's & 10's",
              rank: 'Two Pair'
            },
            playerId: 'jn72g5zxwqr8hz0g8j7yzhd59s81gtha',
            playerName: 'VikingTester',
            userId: 'auth0|68b1fea866fee77b8ca52f6b'
          }
        ]
      },
      {
        potIndex: 2,
        winners: [
          {
            amount: 600,
            hand: {
              cards: ['9h', '5s'],
              description: "Pair, K's",
              rank: 'Pair'
            },
            playerId: 'jn721qzjewxkm8c0wvhxc0tgj581gk1f',
            playerName: 'VikingPPDev',
            userId: 'auth0|68f157a0dd81c0033db63b18'
          }
        ]
      }
    ],
    totalAwarded: 20100
  },
  winners: [
    {
      amount: 19500,
      cards: ['Tc', '2d'],
      handDescription: "Two Pair, K's & 10's",
      handRank: 'Two Pair',
      playerId: 'jn72g5zxwqr8hz0g8j7yzhd59s81gtha',
      playerName: 'VikingTester',
      userId: 'auth0|68b1fea866fee77b8ca52f6b'
    },
    {
      amount: 600,
      cards: ['9h', '5s'],
      handDescription: "Pair, K's",
      handRank: 'Pair',
      playerId: 'jn721qzjewxkm8c0wvhxc0tgj581gk1f',
      playerName: 'VikingPPDev',
      userId: 'auth0|68f157a0dd81c0033db63b18'
    }
  ]
}

export const mockChatMessages = [
  {
    _id: '696903bd18247b826edbd91c',
    channelName: 'a91e34ec-fa60-476c-b0fb-739c1804bffc',
    userName: 'VikingTester',
    message: 'VikingTester joined the game.',
    chatKind: 'dealer',
    userId: '68b1febb02849915c1b7b99f',
    color: 'white',
    timestamp: 1768489917409
  },
  {
    _id: '696903daf40353baa752f2ce',
    channelName: 'a91e34ec-fa60-476c-b0fb-739c1804bffc',
    userName: 'VikingTester',
    message: 'Test',
    chatKind: 'user',
    userId: '68b1febb02849915c1b7b99f',
    color: '#5BC4FF',
    timestamp: 1768489946597
  }
]

// TODO PK: will move to test harness shortly
// biome-ignore lint/suspicious/noExplicitAny: Ok in this generic case
type FirstElement<T extends any[] | readonly any[]> = T[0] // | undefined
type TestHistoryFn = ReturnType<typeof useHandHistoryQuery>['handHistory']
type TestHistoryType = FirstElement<NonNullable<TestHistoryFn>>

type TestHistoryFn2 = (typeof api.hands.queries.getHandHistory)['_returnType']
type TestHistoryType2 = FirstElement<NonNullable<TestHistoryFn2>>

type Equals<X, Y> = (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? true : false

// Verify that both derivations of TestHistoryType are the same
type _VerifyTestHistoryTypeIsSame = Equals<TestHistoryType, TestHistoryType2> extends true ? true : never

// If you get a type error here, the two TestHistoryType definitions are out of sync
const _verifyTestHistoryTypeIsSame: _VerifyTestHistoryTypeIsSame = true
_verifyTestHistoryTypeIsSame

type CheckMatch = Equals<TestHistoryType, Doc<'handHistory'>> extends true ? true : never
// If you get a type error here, the TestHistoryType is out of sync with the data model
const _checkMatch: CheckMatch = true
_checkMatch

type CheckMatch2 = Equals<TestHistoryType2, Doc<'handHistory'>> extends true ? true : never
// If you get a type error here, the TestHistoryType is out of sync with the data model
const _checkMatch2: CheckMatch2 = true
_checkMatch2
